export default __webpack_public_path__ + "static/media/Icono 13.7ced90f1.svg";